'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

export interface AmenitiesHighlightProps {
  description: string;
  facility: {
    id: string;
    title: string;
    description: string;
    thumbnail: string;
  }[];
}

export default function AmenitiesHighlight(props: AmenitiesHighlightProps) {
  return (
    <div className="bg-darkgold py-12 xl:py-36 relative">
      <img
        src="/homepage/stempel.svg"
        alt="logo"
        className="absolute top-28 right-0 hidden xl:block"
      />

      <div className="w-full xl:max-w-screen-xl mx-auto">
        <p
          className="text-white text-[13px] xl:text-3xl text-center xl:leading-12 z-10 relative px-16 xl:px-0"
          dangerouslySetInnerHTML={{ __html: props.description }}
        ></p>

        <div className="hidden xl:grid grid-cols-3 mt-32 gap-x-7 z-10 relative">
          {props.facility.map((facility) => {
            return (
              <div
                key={facility.id}
                className="text-white flex flex-col space-y-5"
              >
                <img
                  src={facility.thumbnail}
                  alt=""
                  loading="lazy"
                  className="rounded-[20px] object-cover h-[331px]"
                />
                <p
                  className="text-3xl font-pluto"
                  dangerouslySetInnerHTML={{ __html: facility.title }}
                ></p>
                <p className="text-2xl xl:mr-10" dangerouslySetInnerHTML={{__html: facility.description}}>
                </p>
              </div>
            );
          })}
        </div>

        {/* mobile version */}
        <Carousel
          opts={{ loop: true }}
          plugins={[
            Autoplay({
              delay: 5000,
            }),
          ]}
          className="block xl:hidden mt-8 px-14"
        >
          <CarouselContent>
            {props.facility.map((facility) => {
              return (
                <CarouselItem
                  key={facility.id}
                  className="text-white flex flex-col"
                >
                  <img
                    src={facility.thumbnail}
                    alt=""
                    className="rounded-[9px] object-cover h-[261px]"
                  />
                  <p
                    className="font-pluto text-center mt-6"
                    dangerouslySetInnerHTML={{ __html: facility.title }}
                  ></p>
                  <p className="text-[13px] text-2xl text-center mt-3">
                    {facility.description}
                  </p>
                </CarouselItem>
              );
            })}
          </CarouselContent>

          <CarouselPrevious className="size-5 top-1/3 left-6 bg-transparent cursor-pointer text-white z-10 border-2 !border-white" />
          <CarouselNext className="size-5 top-1/3 right-6 bg-transparent cursor-pointer text-white z-10 border-2 border-white" />
        </Carousel>
      </div>
    </div>
  );
}
